// main.js — Punto de entrada JavaScript
console.log('MiProyecto cargado correctamente');
